import { useState, useEffect, useContext } from "react";
import {
    Card,
    List,
    Avatar,
    Spin,
    Typography,
    notification,
    Input,
} from "antd";
import {
    BellOutlined,
    CalendarOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import SingleAnnouncement from "./SingleAnnouncement";
import { Fade, Zoom } from "react-awesome-reveal";
import TextType from "../../js/TextType";
import { Badge } from "antd";

const { Text, Paragraph } = Typography;

export default function Announcements() {
    const [announcements, setAnnouncements] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const { authData, backUrl } = useContext(AuthContext);
    const [showSingle, setShowSingle] = useState(false);
    const [singleData, setSingleData] = useState(null);

    const isMobile = window.innerWidth < 480;
    const isTab = window.innerWidth < 768;

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${backUrl}/api/hr/announcements/`, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });
            const data = res.data.results || res.data;
            setAnnouncements(data);
            setFiltered(data);
            // notification.success({
            //     message: "Announcements Loaded",
            //     description: `Fetched ${data.length} announcements`,
            //     placement: "topRight",
            //     duration: 2,
            // });
        } catch (err) {
            console.error("Error fetching announcements:", err);
            // notification.error({
            //     message: "Error Loading Announcements",
            //     description: "Failed to fetch announcements. Please try again later.",
            //     placement: "topRight",
            // });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (authData?.access) fetchData();
    }, [authData]);

    useEffect(() => {
        if (!search.trim()) setFiltered(announcements);
        else {
            setFiltered(
                announcements.filter((item) =>
                    item.title?.toLowerCase().includes(search.toLowerCase())
                )
            );
        }
    }, [search, announcements]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    };

    return (
        <>
            {showSingle ? (
                <SingleAnnouncement
                    singleData={singleData}
                    onBack={() => setShowSingle(false)}
                />
            ) : (
                <Zoom duration={500} triggerOnce>
                    <Card
                        title={
                            <center>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        justifyContent: "center",
                                    }}
                                >
                                    <BellOutlined style={{ color: "#0e497b" }} />
                                    {/* <TextType
                                        text={["Announcements"]}
                                        style={{ color: "#0e497b" }}
                                        typingSpeed={75}
                                        pauseDuration={1500}
                                        showCursor={true}
                                        cursorCharacter="|"
                                    /> */}
                                    <Text strong>Announcements</Text>
                                </span>
                            </center>
                        }
                        size="small"
                        bordered={false}
                        style={{
                            width: "100%",
                            borderRadius: 16,
                            background: "#fff",
                            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.12)",
                            transition: "all 0.3s ease",
                            marginTop: "10px",
                        }}
                        bodyStyle={{ padding: "12px" }}
                    >
                        {/* 🔍 Search Bar */}
                        <Input
                            placeholder="Search by title..."
                            prefix={<SearchOutlined />}
                            allowClear
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{ marginBottom: 12 }}
                        />

                        <Spin spinning={loading}>
                            <List
                                itemLayout="horizontal"
                                size="small"
                                dataSource={filtered}
                                pagination={{
                                    pageSize: 3,
                                    position: "bottom",
                                    align: "center",
                                }}
                                locale={{
                                    emptyText: <Text type="secondary">No announcements found</Text>,
                                }}
                                renderItem={(item, index) => {
                                    const isLatest =
                                        announcements.length > 0 && item.id === announcements[0].id;

                                    return (
                                        <Fade
                                            key={item.id}
                                            direction="up"
                                            delay={index * 100}
                                            triggerOnce
                                        >
                                            {isLatest ? (
                                                <Badge.Ribbon text="New" color="red">
                                                    <List.Item
                                                        onClick={() => {
                                                            setSingleData(item);
                                                            setShowSingle(true);
                                                        }}
                                                        style={{
                                                            backgroundColor: "#cde5fb",
                                                            border: "1px solid #6cb7f9",
                                                            borderRadius: 6,
                                                            marginBottom: 8,
                                                            padding: "12px 16px",
                                                            cursor: "pointer",
                                                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform = "scale(1.02)";
                                                            e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.1)";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform = "scale(1)";
                                                            e.currentTarget.style.boxShadow = "none";
                                                        }}
                                                    >
                                                        <List.Item.Meta
                                                            avatar={<Avatar style={{ backgroundColor: "#0e497b", fontSize: "14px" }} icon={<BellOutlined />} />}
                                                            title={
                                                                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "14px" }}>
                                                                    <Text strong>{item.title}</Text>
                                                                    {item.date && (
                                                                        <span style={{ fontSize: "12px", color: "#999" }}>
                                                                            <CalendarOutlined style={{ marginRight: 4 }} />
                                                                            {formatDate(item.date)}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            }
                                                            description={
                                                                <Paragraph style={{ marginBottom: 0, color: "#595959", fontSize: "13px" }} ellipsis={{ rows: 2 }}>
                                                                    {item.preview}
                                                                </Paragraph>
                                                            }
                                                        />
                                                    </List.Item>
                                                </Badge.Ribbon>
                                            ) : (
                                                <List.Item
                                                    onClick={() => {
                                                        setSingleData(item);
                                                        setShowSingle(true);
                                                    }}
                                                    style={{
                                                        backgroundColor: "#fff",
                                                        border: "1px solid #dddedf",
                                                        borderRadius: 6,
                                                        marginBottom: 8,
                                                        padding: "12px 16px",
                                                        cursor: "pointer",
                                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.transform = "scale(1.02)";
                                                        e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.1)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = "scale(1)";
                                                        e.currentTarget.style.boxShadow = "none";
                                                    }}
                                                >
                                                    <List.Item.Meta
                                                        avatar={<Avatar style={{ backgroundColor: "#0e497b", fontSize: "14px" }} icon={<BellOutlined />} />}
                                                        title={
                                                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "14px" }}>
                                                                <Text strong>{item.title}</Text>
                                                                {item.date && (
                                                                    <span style={{ fontSize: "12px", color: "#999" }}>
                                                                        <CalendarOutlined style={{ marginRight: 4 }} />
                                                                        {formatDate(item.date)}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        }
                                                        description={
                                                            <Paragraph style={{ marginBottom: 0, color: "#595959", fontSize: "13px" }} ellipsis={{ rows: 2 }}>
                                                                {item.preview}
                                                            </Paragraph>
                                                        }
                                                    />
                                                </List.Item>
                                            )}
                                        </Fade>
                                    );
                                }}
                            />
                        </Spin>
                    </Card>
                </Zoom>
            )}
        </>
    );
}
